import React from "react";
import QuestionItem from "../components/QuestionItem";

const BaseQuestions = ({ globalId, wizardForm }) => {
  return (
    <>
      <QuestionItem
        questionIndex={"1"}
        questionName={"qStudyPhase"}
        activator={true}
        questionInputType={"radio"}
        questionInputChoice={"yes_no"}
        globalId={globalId}
      />
      <QuestionItem
        questionIndex={"1a"}
        questionName={"qStudyPhaseNames"}
        activator={wizardForm.controls.qStudyPhase.value === "true"}
        questionInputType={"text"}
      />
      <QuestionItem
        questionIndex={"2"}
        questionName={"qParticipantsName"}
        activator={true}
        questionInputType={"radio"}
        questionInputChoice={"qParticipantsName"}
        globalId={globalId}
      />
      <QuestionItem
        questionIndex={"3"}
        questionName={"qComparative"}
        activator={true}
        questionInputType={"radio"}
        questionInputChoice={"qComparative"}
        globalId={globalId}
      />
    </>
  );
};

export default BaseQuestions;
